"use client";

import { ActivityIcon, SettingsIcon, UsersIcon } from "lucide-react";
import { TabsCard } from "@/components/backoffice/tabs-card";
import { AdministrationConfigurableLists } from "@/components/backoffice/system/administration-configurable-lists";
import { AdministrationActivity } from "@/components/backoffice/system/administration-activity";

const tabs = [
  {
    name: "Listes",
    value: "configurable-lists",
    icon: SettingsIcon,
    content: <AdministrationConfigurableLists />,
  },
  {
    name: "Gestion des Utilisateurs",
    value: "users",
    icon: UsersIcon,
    content: "WIP",
  },

  {
    name: "Logs d'activité",
    value: "logs",
    icon: ActivityIcon,
    content: <AdministrationActivity />,
  },
];

function AdministrationTabsCard() {
  return <TabsCard tabs={tabs} />;
}

export { AdministrationTabsCard };
